import { useState } from "react";
// import axios from "axios";

const GstSearch = () => {
  const [gstNumber, setGstNumber] = useState("");
  const [gstDetails, setGstDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    if (!gstNumber) {
      setError("Please enter a GST number.");
      return;
    }

    setLoading(true);
    setError("");
    setGstDetails(null);

    // try {
    //   const response = await axios.get(
    //     `https://your-api.com/gst-search?gst=${gstNumber}`
    //   );
    //   setGstDetails(response.data);
    // } catch (err) {
    //   setError("Failed to fetch GST details. Please try again.");
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-semibold text-blue-600 text-center mb-4">
        GST Number Search
      </h2>

      <div className="flex gap-2">
        <input
          type="text"
          className="border p-2 w-full rounded-md"
          placeholder="Enter GST Number"
          value={gstNumber}
          onChange={(e) => setGstNumber(e.target.value)}
        />
        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {error && <p className="text-red-500 mt-2">{error}</p>}

      {gstDetails && (
        <div className="mt-4 border p-4 rounded-md bg-gray-100">
          <h3 className="text-lg font-semibold">GST Details</h3>
          <p>
            <strong>Name:</strong> {gstDetails.name}
          </p>
          <p>
            <strong>State:</strong> {gstDetails.state}
          </p>
          <p>
            <strong>Registration Type:</strong> {gstDetails.type}
          </p>
        </div>
      )}
    </div>
  );
};

export default GstSearch;
